import { Injectable } from '@angular/core';

Injectable();
export class Global {
    public openModal = (entries, titleText?) => {
    }
    constructor() { }
}
